import React, { PropsWithChildren } from 'react';
import Link, { LinkProps } from 'next/link';
import { logEventAsArray, TAnalyticArgs } from '@/analytics';
import { Icon } from '@/components/atomic/Icon';
import { classnames } from '@/utils/classnames';

export interface ITextLinkProps extends Pick<TAnchorProps, 'id'> {
  href: LinkProps['href'];
  className?: string;
  target?: string;
  iconSize?: number;
  analytics?: TAnalyticArgs;
}

const TextLink = ({
  id,
  href,
  children,
  className = '',
  target,
  analytics,
  iconSize = 16,
}: PropsWithChildren<ITextLinkProps>) => {
  const handleClick: TDivProps['onClick'] = () => {
    logEventAsArray(analytics);
  };

  return (
    <Link
      href={href}
      target={target}
      {...(target === '_blank' && { rel: 'noopener noreferrer' })}
    >
      <div className="text-blue-a40 " id={id} onClick={handleClick}>
        <div
          className={classnames(
            '-ml-1 flex cursor-pointer items-center justify-center text-xxs font-medium text-blue-a40',
            className
          )}
        >
          {children}
          <Icon icon="chevron_left" size={iconSize} />
        </div>
      </div>
    </Link>
  );
};

export default TextLink;
